import { ClubSwitcherItem } from '@3ddv/software-division-components/backoffice/club-switcher';
import { configurationData } from '../../private/services/configuration-data';

/**
 * The sidebar logo of some clubs is white (it sits on a dark rail), which is
 * invisible on the white switcher panel. Those clubs use their coloured
 * favicon in the switcher instead.
 */
const COLOURED_ICON_CLUBS: ReadonlySet<string> = new Set([
  'washingtonnationals',
]);

export function toClubSwitcherItems(): ClubSwitcherItem[] {
  return Object.entries(configurationData)
    .filter(([slug]) => slug !== 'default')
    .map(([slug, configuration]) => ({
      slug,
      name: configuration.clientName,
      iconUrl: COLOURED_ICON_CLUBS.has(slug)
        ? configuration.favicon
        : configuration.logo,
    }));
}

export function clubSwitchUrl(
  location: Pick<Location, 'protocol' | 'hostname' | 'port'>,
  currentClub: string,
  targetClub: string
): string {
  const host = location.hostname.replace(
    new RegExp(`(^|[.-])${currentClub}(?=\\.)`),
    `$1${targetClub}`
  );
  const port = location.port ? `:${location.port}` : '';

  return `${location.protocol}//${host}${port}/private`;
}
